import React, {Fragment, useEffect} from 'react';
import {Tabs} from '../../../components';
import {Route, Switch, Redirect} from 'react-router-dom';
import Active from './active_payments';
import Invoices from './invoices';
import Subscriptions from './subscriptions';
import Analytics from './analytics';
import {connect} from 'react-redux';



function Index(props){
    if(props.workspace==undefined){return null}
    let subscribed=(props.workspace.active_subscription_id!=null)?true:true;
    return(
      <Switch>
        <Route path='/payments/subscriptions/extension' render={(route)=><Subscriptions {...route} {...props} extension/>}/>
        <Route path='/payments/subscriptions' render={(route)=><Subscriptions {...route} {...props}/>}/>
        <Route path='/payments' render={(route)=>(subscribed==true)?<PaymentSection {...props}/>:<Redirect to='/payments/subscriptions'/>}/>
      </Switch>
    )
}





function PaymentSection(props){


  return(
    <Fragment>
      <Tabs {...props} white tabs={[{title:'Analytics', path:'/payments/analytics'}, {title:'Manage', path:'/payments/active'},{title:'Payments', path:'/payments/history'}]}/>
      <div style={{width:'100%', marginTop:'80px'}}>
        <Switch>
          <Route path='/payments/active'render={(route)=><Active {...route} {...props}/>}/>
          <Route path='/payments/history' render={(route)=><Invoices {...route}{...props}/>}/>
          <Route path='/payments/analytics' render={(route)=><Analytics {...route} {...props}/>}/>
        </Switch>
      </div>
    </Fragment>
  );
}

export default connect(ss,dd)(Index);


function ss(state){
  return {
    workspace:(state.workspaces.data==undefined)?undefined:state.workspaces.data[state.workspaces.current_workspace_id]
  }
}

function dd(dispatch){
  return {}
}
